export type FieldType = {
  label: string;
  type: string;
};

export const FieldTypes: FieldType[] = [
  {
    label: "Titre",
    type: "Title"
  },
  {
    label: "Prénom",
    type: "FirstName"
  },
  {
    label: "Nom",
    type: "LastName"
  },
  {
    label: "Mail",
    type: "Mail"
  },
  {
    label: "Confirmation de mail",
    type: "ConfirmMail"
  },
  {
    label: "Profession et spécialité",
    type: "ProfessionSpecialite"
  },
  {
    label: "Identifiant national",
    type: "NationalId"
  },
  {
    label: "Téléphone",
    type: "Phone"
  },
  {
    label: "Téléphone mobile",
    type: "MobilePhone"
  },
  {
    label: "Commentaire",
    type: "Comment"
  },
  {
    label: "Login",
    type: "Login"
  },
  {
    label: "Mot de passe",
    type: "Password"
  },
  {
    label: "Confirmation de mot de passe",
    type: "ConfirmPassword"
  }
];

export function getFieldType(type: string): FieldType | undefined {
  return FieldTypes.find(ft => ft.type === type);
}
